import Model from '@/models/Model'

export default class WhProductCriticalNotification extends Model {
    //static includes = ['wh_product', 'g_branch_office']
    resource() {
        return 'wh_product_critical_notification'
    }

    get flag_viewed_string (){
      
      return (this.flag_viewed ) ? 'Si' : 'No'
    }
}
